'use client'
import React, { useState } from 'react';

const ItTelecomIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for IT and Telecom Industry</h2>
        </div>
        <h3 className="text-center py-3">Cutting-Edge IT Solutions for the IT & Telecom Industry</h3>
        <p className="text-center py-3">
          JBcodeapp offers comprehensive solutions to address the unique challenges of IT and telecom companies, driving efficiency and innovation.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Telecom Network Management Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Cloud Communication Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Telecom CRM and Billing Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Cybersecurity Solutions for Telecom
                </button>

              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Telecom Network Management Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Cloud Communication Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Telecom CRM and Billing Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Cybersecurity Solutions for Telecom
                </button>

              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3"> Telecom Network Management Solutions</h3>
                        <p>
                          Automate and monitor telecom networks to ensure seamless connectivity and reduce service downtime.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Network Monitoring <br/>Tools</h4>
                          <p>Continuous monitoring of network performance to detect issues in real-time, ensuring optimal service delivery.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Automated Fault <br/>Detection</h4>
                          <p>Rapid identification and reporting of network faults, minimizing downtime and enabling quick resolution.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Network Configuration Management</h4>
                          <p>Streamlined management of network configurations to enhance performance and reduce misconfigurations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-time Alerts & Notifications</h4>
                          <p>Instant alerts for network anomalies, allowing teams to respond swiftly to potential issues before they escalate.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">AI-Powered Predictive Maintenance</h4>
                          <p>Utilize AI to predict network failures and perform maintenance proactively, reducing downtime and operational costs.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Bandwidth Optimization Solutions</h4>
                          <p>Techniques to manage and allocate bandwidth effectively, ensuring high-quality service even during peak usage times.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Cloud Communication Solutions</h3>
                        <p>
                          Empower your telecom business with cloud-based communication services that are scalable, secure, and efficient.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Cloud PBX <br/>Solutions</h4>
                          <p>A cloud-based phone system that offers advanced calling features without the need for physical hardware.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Unified Communication Platforms</h4>
                          <p>Integrate voice, video, messaging, and collaboration tools into a single platform for seamless communication.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">VoIP <br/>Infrastructure</h4>
                          <p>Scalable Voice over Internet Protocol (VoIP) solutions to facilitate cost-effective and high-quality voice communications.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Call Center Management Tools</h4>
                          <p>Comprehensive tools for managing call center operations, including routing, analytics, and reporting.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Data Encryption & Security</h4>
                          <p>Robust encryption protocols to protect communication data and ensure privacy and compliance.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-time Collaboration Tools</h4>
                          <p>Tools that enable teams to collaborate in real-time, enhancing productivity and communication efficiency.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Telecom CRM and Billing Systems</h3>
                        <p>
                          Automate customer relationship management and billing processes to enhance user experience and business efficiency.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Subscription <br/>Management</h4>
                          <p>Tools to manage customer subscriptions easily, including upgrades, renewals, and cancellations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Automated Invoicing & Payments</h4>
                          <p>Streamline billing processes with automated invoicing and payment collection to improve cash flow.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Customer Service <br/>Ticketing</h4>
                          <p>Efficiently track and manage customer inquiries and issues through a comprehensive ticketing system.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Multi-Tier Billing <br/>Solutions</h4>
                          <p>Flexible billing options that support different pricing models, ensuring accurate billing based on usage.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Usage <br/>Tracking</h4>
                          <p>Monitor customer usage in real-time, providing insights for accurate billing and service adjustments.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Analytics & Reporting Dashboards</h4>
                          <p>Comprehensive dashboards that provide insights into customer behavior, billing trends, and service performance.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Cybersecurity Solutions for Telecom</h3>
                        <p>
                          Protect telecom networks with robust cybersecurity frameworks designed to handle increasing data and security threats.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Network Intrusion <br/>Detection</h4>
                          <p>Systems that monitor network traffic for suspicious activities and potential threats, enabling timely responses.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Data Encryption <br/>Technologies</h4>
                          <p>Implementing advanced encryption methods to safeguard sensitive data during transmission and storage.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Secure Access Control Systems</h4>
                          <p>Policies and technologies to manage user access to networks and systems, ensuring only authorized users can connect.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Threat Intelligence & Response</h4>
                          <p>Utilize threat intelligence to anticipate and mitigate potential cyber threats, enhancing overall security posture.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Cloud Security <br/>Solutions</h4>
                          <p>Robust security measures for cloud services, protecting data and applications from unauthorized access.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Identity and Access Management</h4>
                          <p>Solutions to manage user identities and control access to sensitive information, reducing the risk of data breaches.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Five Tab: HIE Solutions */}
              {/* {activeTab === 'five' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Custom ERP for Logistics</h3>
                        <p>
                          Our custom ERP solutions for logistics provide end-to-end control over resource planning, <br />
                          from supply chain management to customer order processing, ensuring smooth operations.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Resource Planning</h4>
                          <p>Plan and allocate resources efficiently to optimize operational workflows.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Order Processing</h4>
                          <p>Streamline the process of managing and processing across the supply chain.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Inventory Control</h4>
                          <p>Monitor and manage inventory levels to ensure supply meets demand.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Supplier Management</h4>
                          <p>Track and manage supplier interactions for timely order fulfillment.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Customer Order Updates</h4>
                          <p>Provide real-time updates to customers on order status and delivery progress.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Reporting and Analytics</h4>
                          <p>Generate detailed reports and analytics for better decision-making.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                </>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default ItTelecomIndustries;
